import { z } from 'zod';
import { PayloadMetaFieldSchema } from './blockPayloadMeta';

const GLOSARIO_PLACEHOLDER_TERM = /^concepto clave$/i;
const GLOSARIO_PLACEHOLDER_DEFINITION = /definici[oó]n relacionada con/i;

export function isGlosarioPlaceholderTerm(term: string): boolean {
  return GLOSARIO_PLACEHOLDER_TERM.test(String(term || '').trim());
}

export function isGlosarioPlaceholderDefinition(definition: string): boolean {
  return GLOSARIO_PLACEHOLDER_DEFINITION.test(String(definition || '').trim());
}

export function isGlosarioPlaceholderEntry(entry: { term?: string; definition?: string }): boolean {
  return (
    isGlosarioPlaceholderTerm(String(entry?.term || '')) ||
    isGlosarioPlaceholderDefinition(String(entry?.definition || ''))
  );
}

export const GLOSARIO_DEFINITION_SEMANTIC_DESCRIPTION =
  'Síntesis Conceptual: no escribas definiciones de diccionario mecánico. Explica cómo este concepto específico impactó o se relaciona con la historia/tema narrado en la guía. Mantenlo breve pero narrativo.';

export const GlosarioTablaEntrySchema = z.object({
  term: z
    .string()
    .trim()
    .min(2, 'glosario term too short')
    .describe('Término clave en texto plano (sin Markdown).')
    .refine((term) => !isGlosarioPlaceholderTerm(term), {
      message: 'glosario term must not be placeholder "Concepto clave"',
    }),
  definition: z
    .string()
    .trim()
    .min(12, 'glosario definition too short')
    .describe(GLOSARIO_DEFINITION_SEMANTIC_DESCRIPTION)
    .refine((definition) => !isGlosarioPlaceholderDefinition(definition), {
      message: 'glosario definition must not contain "Definición relacionada con"',
    }),
});

export const GlosarioTablaPayloadSchema = z
  .object({
    title: z.string().trim().min(1, 'GlosarioTabla requires title'),
    entries: z
      .array(GlosarioTablaEntrySchema)
      .min(1, 'GlosarioTabla requires at least one entry')
      .max(12),
  })
  .merge(PayloadMetaFieldSchema);

export function validateGlosarioTablaPayloadSchema(raw: unknown) {
  return GlosarioTablaPayloadSchema.parse(raw);
}
